import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * /personas 配下のレイアウト。
 * 一覧（index）と詳細（$personaId）は同階層の兄弟ルートで、この Outlet に差し替わる。
 */
export const Route = createFileRoute("/personas")({
  component: PersonasLayout
});

function PersonasLayout() {
  return <Outlet />;
}
